import * as React from "react";
import Menu from "../slideBar";
const RightSideHeader = () => {
  return (
    <React.Fragment>
      <div
        className="flex flex-row-reverse justify-between   py-4 mx-auto w-[90%] 
      screen1000:text-[14px] screen800:text-[12px] screen700:text-[10.5px] screen1800:text-[28px] screen1800:py-"
      >
        <div
          style={{ direction: "rtl" }}
          className="grid grid-cols-2 justify-between  w-full"
        >
          <div className="w-fit -mr-7 screen700:-mr-3 screen500:-mr-2 screen700:-mt-2 screen700:leading-8 screen600:leading-7 screen500:leading-6 screen400:leading-5">
            <h1
              className=" text-[35px] screen1000:text-[30px] screen800:text-[25px]   screen500:text-[18px]  screen700:flex screen700:flex-col screen700:text-center 
             screen400:text-[16px]
            font-extrabold "
            >
              سکه&nbsp;
              <span className="">
                شادمهر  
              </span>
            </h1>
          </div>

          <div className="mr-20 screen1300:mr-14 screen900:mr-10 screen700:mr-7 screen600:mr-6 screen500:mr-5 screen400:mr-4 screen700:-mt-1 ">
            <div className="text-sm leading-8   screen1000:text-xs screen800:text-[10px]
             screen700:text-[8px] screen500:text-[6px]  screen400:text-[5px] screen700:leading-3">
              <h2>با مجوز رسمی از اتحادیه طلا و سکه تهران</h2>
            </div>

            <div className="flex flex-row-reverse justify-end text-sm leading-8  screen700:leading-3
             screen1000:text-xs screen800:text-[10px] screen700:text-[8px] screen00:text-[6px] screen400:text-[5px] ">
              <h2 className=" ">شماره ثبت : 7172</h2>
            </div>
          </div>
        </div>

        <div className="">
          <Menu />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RightSideHeader;
